import { Box, Tab, Tabs, Typography } from "@mui/material";
import { useState } from "react";

import DrawSignature from "./DrawSignature";
import TypedSignature from "./TypedSignature";

type Data = { type: string; dataURL: string };
const SignatureAdoptionComponent = ({
  onAdopt,
}: {
  onAdopt: (data: Data) => void;
}) => {
  const [signatureType, setSignatureType] = useState(0); // 0: Typed, 1: Drawn

  const onSave = (data: Data) => {
    onAdopt(data);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Typography variant="subtitle1" align="center" gutterBottom>
        Adopt Your Signature
      </Typography>

      {/* Tab Selector */}
      <Tabs
        value={signatureType}
        onChange={(e, newValue) => setSignatureType(newValue)}
        centered
        sx={{ mb: 1 }}
      >
        <Tab label="Text" sx={{ textTransform: "none" }} />
        <Tab label="Draw" sx={{ textTransform: "none" }} />
      </Tabs>

      {/* Typed or Draw Signature */}
      {signatureType === 0 && (
        <TypedSignature onSave={onSave} fontsSelecatbale={false} />
      )}
      {signatureType === 1 && <DrawSignature onSave={onSave} />}
    </Box>
  );
};

export default SignatureAdoptionComponent;
